var map = {
	"./1965": [
		"./src/components/winners/tables/1965.ts",
		"src_components_winners_tables_1965_ts"
	],
	"./1965.ts": [
		"./src/components/winners/tables/1965.ts",
		"src_components_winners_tables_1965_ts"
	],
	"./1966": [
		"./src/components/winners/tables/1966.ts",
		"src_components_winners_tables_1966_ts"
	],
	"./1966.ts": [
		"./src/components/winners/tables/1966.ts",
		"src_components_winners_tables_1966_ts"
	],
	"./1967": [
		"./src/components/winners/tables/1967.ts",
		"src_components_winners_tables_1967_ts"
	],
	"./1967.ts": [
		"./src/components/winners/tables/1967.ts",
		"src_components_winners_tables_1967_ts"
	],
	"./1968": [
		"./src/components/winners/tables/1968.ts",
		"src_components_winners_tables_1968_ts"
	],
	"./1968.ts": [
		"./src/components/winners/tables/1968.ts",
		"src_components_winners_tables_1968_ts"
	],
	"./1969": [
		"./src/components/winners/tables/1969.ts",
		"src_components_winners_tables_1969_ts"
	],
	"./1969.ts": [
		"./src/components/winners/tables/1969.ts",
		"src_components_winners_tables_1969_ts"
	],
	"./1970": [
		"./src/components/winners/tables/1970.ts",
		"src_components_winners_tables_1970_ts"
	],
	"./1970.ts": [
		"./src/components/winners/tables/1970.ts",
		"src_components_winners_tables_1970_ts"
	],
	"./1971": [
		"./src/components/winners/tables/1971.ts",
		"src_components_winners_tables_1971_ts"
	],
	"./1971.ts": [
		"./src/components/winners/tables/1971.ts",
		"src_components_winners_tables_1971_ts"
	],
	"./1972": [
		"./src/components/winners/tables/1972.ts",
		"src_components_winners_tables_1972_ts"
	],
	"./1972.ts": [
		"./src/components/winners/tables/1972.ts",
		"src_components_winners_tables_1972_ts"
	],
	"./1973": [
		"./src/components/winners/tables/1973.ts",
		"src_components_winners_tables_1973_ts"
	],
	"./1973.ts": [
		"./src/components/winners/tables/1973.ts",
		"src_components_winners_tables_1973_ts"
	],
	"./1974": [
		"./src/components/winners/tables/1974.ts",
		"src_components_winners_tables_1974_ts"
	],
	"./1974.ts": [
		"./src/components/winners/tables/1974.ts",
		"src_components_winners_tables_1974_ts"
	],
	"./1975": [
		"./src/components/winners/tables/1975.ts",
		"src_components_winners_tables_1975_ts"
	],
	"./1975.ts": [
		"./src/components/winners/tables/1975.ts",
		"src_components_winners_tables_1975_ts"
	],
	"./1976": [
		"./src/components/winners/tables/1976.ts",
		"src_components_winners_tables_1976_ts"
	],
	"./1976.ts": [
		"./src/components/winners/tables/1976.ts",
		"src_components_winners_tables_1976_ts"
	],
	"./1977": [
		"./src/components/winners/tables/1977.ts",
		"src_components_winners_tables_1977_ts"
	],
	"./1977.ts": [
		"./src/components/winners/tables/1977.ts",
		"src_components_winners_tables_1977_ts"
	],
	"./1978": [
		"./src/components/winners/tables/1978.ts",
		"src_components_winners_tables_1978_ts"
	],
	"./1978.ts": [
		"./src/components/winners/tables/1978.ts",
		"src_components_winners_tables_1978_ts"
	],
	"./1979": [
		"./src/components/winners/tables/1979.ts",
		"src_components_winners_tables_1979_ts"
	],
	"./1979.ts": [
		"./src/components/winners/tables/1979.ts",
		"src_components_winners_tables_1979_ts"
	],
	"./1980": [
		"./src/components/winners/tables/1980.ts",
		"src_components_winners_tables_1980_ts"
	],
	"./1980.ts": [
		"./src/components/winners/tables/1980.ts",
		"src_components_winners_tables_1980_ts"
	],
	"./1981": [
		"./src/components/winners/tables/1981.ts",
		"src_components_winners_tables_1981_ts"
	],
	"./1981.ts": [
		"./src/components/winners/tables/1981.ts",
		"src_components_winners_tables_1981_ts"
	],
	"./1982": [
		"./src/components/winners/tables/1982.ts",
		"src_components_winners_tables_1982_ts"
	],
	"./1982.ts": [
		"./src/components/winners/tables/1982.ts",
		"src_components_winners_tables_1982_ts"
	],
	"./1983": [
		"./src/components/winners/tables/1983.ts",
		"src_components_winners_tables_1983_ts"
	],
	"./1983.ts": [
		"./src/components/winners/tables/1983.ts",
		"src_components_winners_tables_1983_ts"
	],
	"./1984": [
		"./src/components/winners/tables/1984.ts",
		"src_components_winners_tables_1984_ts"
	],
	"./1984.ts": [
		"./src/components/winners/tables/1984.ts",
		"src_components_winners_tables_1984_ts"
	],
	"./1985": [
		"./src/components/winners/tables/1985.ts",
		"src_components_winners_tables_1985_ts"
	],
	"./1985.ts": [
		"./src/components/winners/tables/1985.ts",
		"src_components_winners_tables_1985_ts"
	],
	"./1986": [
		"./src/components/winners/tables/1986.ts",
		"src_components_winners_tables_1986_ts"
	],
	"./1986.ts": [
		"./src/components/winners/tables/1986.ts",
		"src_components_winners_tables_1986_ts"
	],
	"./1987": [
		"./src/components/winners/tables/1987.ts",
		"src_components_winners_tables_1987_ts"
	],
	"./1987.ts": [
		"./src/components/winners/tables/1987.ts",
		"src_components_winners_tables_1987_ts"
	],
	"./1988": [
		"./src/components/winners/tables/1988.ts",
		"src_components_winners_tables_1988_ts"
	],
	"./1988.ts": [
		"./src/components/winners/tables/1988.ts",
		"src_components_winners_tables_1988_ts"
	],
	"./1989": [
		"./src/components/winners/tables/1989.ts",
		"src_components_winners_tables_1989_ts"
	],
	"./1989.ts": [
		"./src/components/winners/tables/1989.ts",
		"src_components_winners_tables_1989_ts"
	],
	"./1990": [
		"./src/components/winners/tables/1990.ts",
		"src_components_winners_tables_1990_ts"
	],
	"./1990.ts": [
		"./src/components/winners/tables/1990.ts",
		"src_components_winners_tables_1990_ts"
	],
	"./1991": [
		"./src/components/winners/tables/1991.ts",
		"src_components_winners_tables_1991_ts"
	],
	"./1991.ts": [
		"./src/components/winners/tables/1991.ts",
		"src_components_winners_tables_1991_ts"
	],
	"./1992": [
		"./src/components/winners/tables/1992.ts",
		"src_components_winners_tables_1992_ts"
	],
	"./1992.ts": [
		"./src/components/winners/tables/1992.ts",
		"src_components_winners_tables_1992_ts"
	],
	"./1993": [
		"./src/components/winners/tables/1993.ts",
		"src_components_winners_tables_1993_ts"
	],
	"./1993.ts": [
		"./src/components/winners/tables/1993.ts",
		"src_components_winners_tables_1993_ts"
	],
	"./1994": [
		"./src/components/winners/tables/1994.ts",
		"src_components_winners_tables_1994_ts"
	],
	"./1994.ts": [
		"./src/components/winners/tables/1994.ts",
		"src_components_winners_tables_1994_ts"
	],
	"./1995": [
		"./src/components/winners/tables/1995.ts",
		"src_components_winners_tables_1995_ts"
	],
	"./1995.ts": [
		"./src/components/winners/tables/1995.ts",
		"src_components_winners_tables_1995_ts"
	],
	"./1996": [
		"./src/components/winners/tables/1996.ts",
		"src_components_winners_tables_1996_ts"
	],
	"./1996.ts": [
		"./src/components/winners/tables/1996.ts",
		"src_components_winners_tables_1996_ts"
	],
	"./1997": [
		"./src/components/winners/tables/1997.ts",
		"src_components_winners_tables_1997_ts"
	],
	"./1997.ts": [
		"./src/components/winners/tables/1997.ts",
		"src_components_winners_tables_1997_ts"
	],
	"./1998": [
		"./src/components/winners/tables/1998.ts",
		"src_components_winners_tables_1998_ts"
	],
	"./1998.ts": [
		"./src/components/winners/tables/1998.ts",
		"src_components_winners_tables_1998_ts"
	],
	"./1999": [
		"./src/components/winners/tables/1999.ts",
		"src_components_winners_tables_1999_ts"
	],
	"./1999.ts": [
		"./src/components/winners/tables/1999.ts",
		"src_components_winners_tables_1999_ts"
	],
	"./2000": [
		"./src/components/winners/tables/2000.ts",
		"src_components_winners_tables_2000_ts"
	],
	"./2000.ts": [
		"./src/components/winners/tables/2000.ts",
		"src_components_winners_tables_2000_ts"
	],
	"./2001": [
		"./src/components/winners/tables/2001.ts",
		"src_components_winners_tables_2001_ts"
	],
	"./2001.ts": [
		"./src/components/winners/tables/2001.ts",
		"src_components_winners_tables_2001_ts"
	],
	"./2002": [
		"./src/components/winners/tables/2002.ts",
		"src_components_winners_tables_2002_ts"
	],
	"./2002.ts": [
		"./src/components/winners/tables/2002.ts",
		"src_components_winners_tables_2002_ts"
	],
	"./2003": [
		"./src/components/winners/tables/2003.ts",
		"src_components_winners_tables_2003_ts"
	],
	"./2003.ts": [
		"./src/components/winners/tables/2003.ts",
		"src_components_winners_tables_2003_ts"
	],
	"./2004": [
		"./src/components/winners/tables/2004.ts",
		"src_components_winners_tables_2004_ts"
	],
	"./2004.ts": [
		"./src/components/winners/tables/2004.ts",
		"src_components_winners_tables_2004_ts"
	],
	"./2005": [
		"./src/components/winners/tables/2005.ts",
		"src_components_winners_tables_2005_ts"
	],
	"./2005.ts": [
		"./src/components/winners/tables/2005.ts",
		"src_components_winners_tables_2005_ts"
	],
	"./2006": [
		"./src/components/winners/tables/2006.ts",
		"src_components_winners_tables_2006_ts"
	],
	"./2006.ts": [
		"./src/components/winners/tables/2006.ts",
		"src_components_winners_tables_2006_ts"
	],
	"./2007": [
		"./src/components/winners/tables/2007.ts",
		"src_components_winners_tables_2007_ts"
	],
	"./2007.ts": [
		"./src/components/winners/tables/2007.ts",
		"src_components_winners_tables_2007_ts"
	],
	"./2008": [
		"./src/components/winners/tables/2008.ts",
		"src_components_winners_tables_2008_ts"
	],
	"./2008.ts": [
		"./src/components/winners/tables/2008.ts",
		"src_components_winners_tables_2008_ts"
	],
	"./2009": [
		"./src/components/winners/tables/2009.ts",
		"src_components_winners_tables_2009_ts"
	],
	"./2009.ts": [
		"./src/components/winners/tables/2009.ts",
		"src_components_winners_tables_2009_ts"
	],
	"./2010": [
		"./src/components/winners/tables/2010.ts",
		"src_components_winners_tables_2010_ts"
	],
	"./2010.ts": [
		"./src/components/winners/tables/2010.ts",
		"src_components_winners_tables_2010_ts"
	],
	"./2011": [
		"./src/components/winners/tables/2011.ts",
		"src_components_winners_tables_2011_ts"
	],
	"./2011.ts": [
		"./src/components/winners/tables/2011.ts",
		"src_components_winners_tables_2011_ts"
	],
	"./2012": [
		"./src/components/winners/tables/2012.ts",
		"src_components_winners_tables_2012_ts"
	],
	"./2012.ts": [
		"./src/components/winners/tables/2012.ts",
		"src_components_winners_tables_2012_ts"
	],
	"./2013": [
		"./src/components/winners/tables/2013.ts",
		"src_components_winners_tables_2013_ts"
	],
	"./2013.ts": [
		"./src/components/winners/tables/2013.ts",
		"src_components_winners_tables_2013_ts"
	],
	"./2014": [
		"./src/components/winners/tables/2014.ts",
		"src_components_winners_tables_2014_ts"
	],
	"./2014.ts": [
		"./src/components/winners/tables/2014.ts",
		"src_components_winners_tables_2014_ts"
	],
	"./2015": [
		"./src/components/winners/tables/2015.ts",
		"src_components_winners_tables_2015_ts"
	],
	"./2015.ts": [
		"./src/components/winners/tables/2015.ts",
		"src_components_winners_tables_2015_ts"
	],
	"./2016": [
		"./src/components/winners/tables/2016.ts",
		"src_components_winners_tables_2016_ts"
	],
	"./2016.ts": [
		"./src/components/winners/tables/2016.ts",
		"src_components_winners_tables_2016_ts"
	],
	"./2017": [
		"./src/components/winners/tables/2017.ts",
		"src_components_winners_tables_2017_ts"
	],
	"./2017.ts": [
		"./src/components/winners/tables/2017.ts",
		"src_components_winners_tables_2017_ts"
	],
	"./2018": [
		"./src/components/winners/tables/2018.ts",
		"src_components_winners_tables_2018_ts"
	],
	"./2018.ts": [
		"./src/components/winners/tables/2018.ts",
		"src_components_winners_tables_2018_ts"
	],
	"./2019": [
		"./src/components/winners/tables/2019.ts",
		"src_components_winners_tables_2019_ts"
	],
	"./2019.ts": [
		"./src/components/winners/tables/2019.ts",
		"src_components_winners_tables_2019_ts"
	],
	"./2020": [
		"./src/components/winners/tables/2020.ts",
		"src_components_winners_tables_2020_ts"
	],
	"./2020.ts": [
		"./src/components/winners/tables/2020.ts",
		"src_components_winners_tables_2020_ts"
	],
	"./2021": [
		"./src/components/winners/tables/2021.ts",
		"src_components_winners_tables_2021_ts"
	],
	"./2021.ts": [
		"./src/components/winners/tables/2021.ts",
		"src_components_winners_tables_2021_ts"
	],
	"./2022": [
		"./src/components/winners/tables/2022.ts",
		"src_components_winners_tables_2022_ts"
	],
	"./2022.ts": [
		"./src/components/winners/tables/2022.ts",
		"src_components_winners_tables_2022_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/components/winners/tables lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;